import { required, decimal } from 'vuelidate/lib/validators';

const validations = {
  code: {
    required,
  },
  mpc: {
    required,
    decimal,
  },
  vpc: {
    required,
    decimal,
  },
};

export default validations;